import React, {useEffect} from 'react';
import { Route } from 'react-router-dom';

function PrivateRoute ({component: Component, ...rest}) {

    const isAuthenticated = () => localStorage.getItem('jwt-token')

    useEffect(() => {
        if (!isAuthenticated()) {
            window.location.assign('/auth/login?redirectPath=' + window.location.pathname)
        }
    })
    return (
        <Route
            {...rest}
            render={(props) => isAuthenticated() ? <Component {...props} /> : null}
        />
    )
}

export default PrivateRoute
